import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import "./ModalCita.css";
import {addCita,updateCita,getWhatsappManualCita,marcarRecordatorioEnviado,getPersonasSinAlta,
  getTextoFicha,
} from "../../../../../services/citas";
import { getPacientes } from "../../../../../services/pacientes";
import whatsappIcon from "../../../../../assets/WhatsApp.png";
import {quitarAcentos,validarNombreLongitud,validarNombreEspacios,validarNombreCaracteres,} from "../../../../../utils/validaciones/identidad";
import {msgNombreLongitud, msgNombreEspacios, msgNombreCaracteres,
msgApellidoPaternoLongitud, msgApellidoPaternoEspacios, msgApellidoPaternoCaracteres,
msgApellidoMaternoLongitud, msgApellidoMaternoEspacios, msgApellidoMaternoCaracteres,
} from "../../../../../utils/validaciones/mensajes";

const ModalCita = ({ cita, onGuardar, onEliminar, onCerrar }) => {
  const [pacientes, setPacientes] = useState([]); //esto trae la lista de pacientes 
  const [fecha, setFecha] = useState("");
  const [personasSinAlta, setPersonasSinAlta] = useState([]); // personas agendadas sin expediente
  // 🔹 Persona elegida para la cita:
  //    { tipo: "oficial" | "sin_alta" | "personal", id, nombre }
  //    null = todavía no se elige nada (cita nueva)
  const [seleccion, setSeleccion] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [mostrarLista, setMostrarLista] = useState(false);

  // 🔹 Persona nueva (sin expediente)
  const [modoPersonaNueva, setModoPersonaNueva] = useState(false);
  const [personaNueva, setPersonaNueva] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    telefono: "",
    correo: "",
  });
  const [start_time, setstart_time] = useState("");
  const [end_time, setend_time] = useState("");
  const [end_date, setend_date] = useState(""); // Nueva fecha de fin
  const [motivo, setMotivo] = useState("");
  const [userChangedend_time, setUserChangedend_time] = useState(false);
  const [status, setStatus] = useState("activa"); // Por defecto, la cita es activa
  const [color, setColor] = useState("");
  const [whatsappManual, setWhatsappManual] = useState(null);
  const [loadingWhatsappManual, setLoadingWhatsappManual] = useState(false);
  const [guardandoCita, setGuardandoCita] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const cargarPacientes = async () => {
        try {
            const listaPacientes = await getPacientes();
            setPacientes(listaPacientes);
            const listaSinAlta = await getPersonasSinAlta();
            setPersonasSinAlta(listaSinAlta);

        } catch (error) {
            console.error("Error cargando pacientes:", error);
        }
    };
    cargarPacientes();

    if (cita) {
     
        setFecha(cita.fecha || "");
        setStatus(cita.status || "activa"); 

        // 🕒 Convertir start_time a formato 24h y calcular end_time
        if (cita.start_time) {
          setstart_time(cita.start_time);

            // 🎯 Calculamos end_time sumando 1 hora
            if (!cita.end_time) {
              const [hours, minutes] = cita.start_time.split(":").map(Number);
              let newEndHours = hours + 1;
              let newend_date = cita.fecha; // Inicialmente, misma fecha
      
              if (newEndHours === 24) {
                  newEndHours = 0; // Si pasa la medianoche, vuelve a 00:00
                  let nextDay = new Date(cita.fecha);
                  nextDay.setDate(nextDay.getDate() + 1);
                  newend_date = nextDay.toISOString().split("T")[0];
              }
      
              const formattedend_time = `${String(newEndHours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
              setend_time(formattedend_time);
              setend_date(newend_date);
          } else {
              // ✅ Si ya existe un end_time guardado, úsalo en vez de sobrescribirlo
              setend_time(cita.end_time);
              setend_date(cita.end_date || cita.fecha);
          }
      } else {
          setstart_time("");
          setend_time("");  // Si no hay hora inicial, end_time queda vacío
          setend_date(cita.fecha || "");
      }

        setMotivo(cita.motivo || "");
        setColor(cita.color || "");
        
        // 🔹 Reconocer a quién pertenece la cita
        if (cita.paciente) {
          setSeleccion({ tipo: "oficial", id: cita.paciente, nombre: cita.paciente_nombre || "" });
        } else if (cita.paciente_cita) {
          setSeleccion({ tipo: "sin_alta", id: cita.paciente_cita, nombre: cita.paciente_nombre || "" });
        } else if (cita.id) {
          setSeleccion({ tipo: "personal", id: null, nombre: "Cita personal" });
        } else {
          setSeleccion(null);
        }
        setModoPersonaNueva(false);
    }

    // 🎯 Escuchar mensajes para actualizar la lista de pacientes cuando se cierre Alta Paciente
    const handleMessage = (event) => {
        if (event.data?.type === "refreshPacientes") {
            cargarPacientes(); // 🔄 Recargar la lista de pacientes
        }
    };

    window.addEventListener("message", handleMessage);
    return () => {
        window.removeEventListener("message", handleMessage);
    };
}, [cita]);

useEffect(() => {
  const cargarWhatsappManual = async () => {
    if (!cita?.id) {
      setWhatsappManual(null);
      return;
    }

    setLoadingWhatsappManual(true);

    try {
      const data = await getWhatsappManualCita(cita.id);
      setWhatsappManual(data);
    } catch (error) {
      console.error("Error cargando WhatsApp manual:", error);
      setWhatsappManual(null);
    } finally {
      setLoadingWhatsappManual(false);
    }
  };

  cargarWhatsappManual();
}, [cita]);


  // 🕒 Función para actualizar la hora y fecha de fin cuando cambia la hora de inicio
  const handlestart_timeChange = (e) => {
    const newstart_time = e.target.value;
    setstart_time(newstart_time);
  
    const [hours, minutes] = newstart_time.split(":").map(Number);
    let newend_time = new Date();
    newend_time.setHours(hours + 1); // Suma 1 hora
    newend_time.setMinutes(minutes);
  
    // Si la nueva hora de fin es después de medianoche, cambia la fecha de fin
    if (newend_time.getHours() === 0) {
      let nextDay = new Date(fecha);
      nextDay.setDate(nextDay.getDate() + 1);
      setend_date(nextDay.toISOString().split("T")[0]); // Nueva fecha de fin
    } else {
      setend_date(fecha);
    }
  
    // Si el usuario aún no ha cambiado la hora de fin manualmente, se asigna automáticamente
    if (!userChangedend_time || !end_time) {
      setend_time(newend_time.toTimeString().slice(0, 5));
    }
  };

 // 🕒 Actualiza la hora de fin sin validación en tiempo real
const handleend_timeChange = (e) => {
  setUserChangedend_time(true);
  setend_time(e.target.value);
};

const handleCancelarCita = async () => {
  if (!cita) return;

  const confirmacion = window.confirm("⚠️ ¿Estás seguro de que deseas cancelar esta cita?");
  if (!confirmacion) return;

  // 🔹 Eliminamos los datos innecesarios antes de enviar
  const { startMinutes, endMinutes, dayIndex, _idx, column, widthPercentage, leftOffset, ...citaLimpia } = cita;
  const citaCancelada = { ...citaLimpia, status: "cancelada" };

  try {
      await updateCita(cita.id, { status: "cancelada" });
      onGuardar(citaCancelada);
      onCerrar();
  } catch (error) {
      console.error("Error al cancelar la cita:", error);
  }
};

const handleEliminarCita = async () => {
  if (!cita) return;

  const confirmacion = window.confirm(  "❌ ¿Seguro que quieres eliminar esta cita? Esto no se puede deshacer.\n\n" +
    "⚠️ Recuerda: Si eliminas esta cita, no contará en la métrica de cancelaciones, " +
    "lo que puede afectar el seguimiento de tus datos.");
  if (!confirmacion) return;

  try {
      await onEliminar(cita.id);
      onCerrar();
  } catch (error) {
      console.error("Error al eliminar la cita:", error);
  }
};


const limpiarTelefonoWhatsApp = (telefono) => {
  const digitos = String(telefono || "").replace(/\D/g, "");

  if (digitos.length === 10) {
    return `52${digitos}`;
  }

  return digitos;
};

const handleEnviarWhatsappManual = async () => {
  if (!whatsappManual?.puede_enviar) return;

  const telefono = limpiarTelefonoWhatsApp(whatsappManual.telefono_destino);
  const mensajeBase = whatsappManual.mensaje || "";

  if (!telefono || !mensajeBase) {
    alert("No se pudo preparar el mensaje de WhatsApp.");
    return;
  }

  // Si a esta persona le toca ficha, se crea el link y se pega al final del mensaje
  const textoFicha = await getTextoFicha(cita.id);
  const mensaje = encodeURIComponent(
    textoFicha ? `${mensajeBase}\n\n${textoFicha}` : mensajeBase
  );

  window.open(`https://wa.me/${telefono}?text=${mensaje}`, "_blank");

  if (whatsappManual.recordatorio_id) {
    const actualizado = await marcarRecordatorioEnviado(
      whatsappManual.recordatorio_id
    );

    if (actualizado) {
      setWhatsappManual((prev) => ({
        ...prev,
        status: "enviado",
        label:
          prev?.tipo === "confirmacion"
            ? "Reenviar confirmación por WhatsApp"
            : "Reenviar recordatorio por WhatsApp",
      }));
    }
  }
};

// 🔹 Función para guardar la cita con la validación dentro
const handleGuardar = async () => {
  // Candado anti-doble-click.
  if (guardandoCita) return;
  // 📌 Validación antes de enviar
  if (start_time && end_time && fecha === end_date && end_time < start_time) {
      alert("La hora de fin no puede ser menor a la hora de inicio.");
      return; // ❌ No guarda la cita si la validación falla
  }

  // 🔹 Persona nueva: mismos candados que Alta Paciente
  let personaLimpia = null;
  if (modoPersonaNueva) {
    const validarParteNombre = (valor, msgLongitud, msgEspacios, msgCaracteres) => {
      if (!validarNombreLongitud(valor)) { msgLongitud(); return false; }
      if (!validarNombreEspacios(valor)) { msgEspacios(); return false; }
      if (!validarNombreCaracteres(valor)) { msgCaracteres(); return false; }
      return true;
    };

    const nombre = quitarAcentos(personaNueva.nombre.trim());
    const apellidoPaterno = quitarAcentos(personaNueva.apellido_paterno.trim());
    const apellidoMaterno = quitarAcentos(personaNueva.apellido_materno.trim());
    const telefono = personaNueva.telefono.trim();
    const correo = personaNueva.correo.trim();

    if (!nombre) {
      alert("Escribe el nombre de la persona.");
      return;
    }
    if (!validarParteNombre(nombre, msgNombreLongitud, msgNombreEspacios, msgNombreCaracteres)) return;
    if (apellidoPaterno && !validarParteNombre(apellidoPaterno, msgApellidoPaternoLongitud, msgApellidoPaternoEspacios, msgApellidoPaternoCaracteres)) return;
    if (apellidoMaterno && !validarParteNombre(apellidoMaterno, msgApellidoMaternoLongitud, msgApellidoMaternoEspacios, msgApellidoMaternoCaracteres)) return;

    if (!telefono && !correo) {
      alert("Captura al menos un teléfono o un correo.");
      return;
    }
    if (telefono && !/^\d{10}$/.test(telefono)) {
      alert("❌ El teléfono debe tener exactamente 10 dígitos numéricos.");
      return;
    }

    personaLimpia = {
      nombre,
      apellido_paterno: apellidoPaterno,
      apellido_materno: apellidoMaterno,
      telefono,
      correo,
    };
  }

    // 🔹 Si no se eligió a nadie, se confirma que es cita personal
    if (!seleccion && !modoPersonaNueva) {
    const confirmacion = window.confirm(
      "⚡ Puedes continuar sin asignar un paciente (cita personal), pero te recomendamos asignar uno para un mejor seguimiento médico.\n\n" +
      "¿Deseas continuar?"
    );
    if (!confirmacion) return;
  }

  const esPersonal = !modoPersonaNueva && (!seleccion || seleccion.tipo === "personal");

  const motivoFinal = esPersonal
    ? (motivo.trim() || "Cita personal")
    : (motivo.trim() === "Cita personal" ? "" : motivo);

  const statusFinal =
    cita?.status === "cancelada"
      ? "activa"
      : status;

  const nuevaCita = {
    fecha,
    start_time,
    end_time,
    end_date,
    motivo: motivoFinal,
    status: statusFinal,
    color,
  };

  // 🔹 A quién pertenece la cita
  
     if (modoPersonaNueva) {
    nuevaCita.persona_nueva = personaLimpia;         // persona nueva, ya validada
  } else if (seleccion?.tipo === "oficial") {
    nuevaCita.paciente = seleccion.id;               // paciente con expediente
  } else if (seleccion?.tipo === "sin_alta") {
    nuevaCita.paciente_cita_id = seleccion.id;      // persona sin alta
  } else {
    nuevaCita.paciente = null;                      // cita personal
  }
  
 
  setGuardandoCita(true);
  try {
    let citaGuardada;
   const esNuevaCita = !(cita && cita.id);

    if (cita && cita.id) {
      citaGuardada = await updateCita(cita.id, nuevaCita);
    } else {
      citaGuardada = await addCita(nuevaCita);
    }

    if (citaGuardada) {
      if (esNuevaCita) {
        const whatsapp = await getWhatsappManualCita(citaGuardada.id);

        if (
          whatsapp?.puede_enviar &&
          whatsapp?.tipo === "confirmacion"
        ) {
          const telefono = limpiarTelefonoWhatsApp(whatsapp.telefono_destino);
          const mensajeBase = whatsapp.mensaje || "";

          if (telefono && mensajeBase) {
            // Si a esta persona le toca ficha, se crea el link y se pega al final del mensaje
            const textoFicha = await getTextoFicha(citaGuardada.id);
            const mensaje = encodeURIComponent(
              textoFicha ? `${mensajeBase}\n\n${textoFicha}` : mensajeBase
            );
            window.open(`https://wa.me/${telefono}?text=${mensaje}`, "_blank");

            if (whatsapp.recordatorio_id) {
              await marcarRecordatorioEnviado(whatsapp.recordatorio_id);
            }
          }
        }
      }

      onGuardar(citaGuardada);
      onCerrar();
    } else {
      alert("Error al guardar la cita.");
    }
  } catch (error) {
    console.error("Error al guardar la cita:", error);
  } finally {
    setGuardandoCita(false);
  }
};

// 🔹 Opciones del buscador: pacientes con expediente + personas sin alta
const nombrePaciente = (p) =>
  `${p.nombre} ${p.apellido_paterno}${p.apellido_materno ? " " + p.apellido_materno : ""}`.trim();

const textoBusqueda = busqueda.trim().toLowerCase();

const opcionesOficiales = pacientes
  .filter((p) => p.activo === true)
  .map((p) => ({ tipo: "oficial", id: p.id, nombre: nombrePaciente(p) }));

const opcionesSinAlta = personasSinAlta.map((p) => ({
  tipo: "sin_alta",
  id: p.id,
  nombre: p.nombre_completo,
}));

const opcionesFiltradas = [...opcionesOficiales, ...opcionesSinAlta]
  .filter((o) => !textoBusqueda || o.nombre.toLowerCase().includes(textoBusqueda))
  .sort((a, b) => a.nombre.localeCompare(b.nombre));

const elegirOpcion = (opcion) => {
  setSeleccion(opcion);
  setBusqueda("");
  setMostrarLista(false);
  setModoPersonaNueva(false);
};
  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal-container">
        <h2>{cita?.id ? "Editar Cita" : "Nueva Cita"}</h2>
                {cita?.origen === "publico" && (
          <div className="aviso-en-linea">
            🌐 Agendada en línea por el paciente
            {cita.primera_vez_declarada === true && " · Primera vez"}
            {cita.primera_vez_declarada === false && " · Seguimiento"}
          </div>
        )}
        <div className="info-alert">
        ⚡ Puede registrar rápidamente a una persona nueva con nombre y teléfono y enviarle un enlace para que prellene su ficha de identificación. Estos datos son preliminares: el alta oficial en el expediente clínico debe realizarla el médico mediante "Completar alta", donde se validan conforme a la normativa y su revisión y veracidad quedan bajo su responsabilidad.
        </div>
        
               <label>Paciente:</label>

        {modoPersonaNueva ? (
          <div className="persona-nueva">
            <input
              type="text"
              placeholder="Nombre *"
              maxLength={50}
              value={personaNueva.nombre}
              onChange={(e) => setPersonaNueva({ ...personaNueva, nombre: e.target.value })}
            />
            <input
              type="text"
              placeholder="Apellido paterno"
              maxLength={50}
              value={personaNueva.apellido_paterno}
              onChange={(e) => setPersonaNueva({ ...personaNueva, apellido_paterno: e.target.value })}
            />
            <input
              type="text"
              placeholder="Apellido materno"
              maxLength={50}
              value={personaNueva.apellido_materno}
              onChange={(e) => setPersonaNueva({ ...personaNueva, apellido_materno: e.target.value })}
            />
           <input
              type="tel"
              placeholder="Teléfono (10 dígitos)"
              maxLength={10}
              inputMode="numeric"
              value={personaNueva.telefono}
              onChange={(e) => setPersonaNueva({ ...personaNueva, telefono: e.target.value.replace(/\D/g, "") })}
            />
            <input
              type="email"
              placeholder="Correo"
              maxLength={100}
              value={personaNueva.correo}
              onChange={(e) => setPersonaNueva({ ...personaNueva, correo: e.target.value })}
            />
            <small>Captura al menos un teléfono o un correo.</small>
            <button type="button" onClick={() => setModoPersonaNueva(false)}>Cancelar</button>
          </div>
        ) : seleccion ? (
          <div className="seleccion-actual">
            <span>{seleccion.nombre}</span>
            {seleccion.tipo === "sin_alta" && (
              <span className="etiqueta-sin-alta">Sin alta</span>
            )}
            {/* El paciente ya llenó su ficha: el médico puede dar el alta con sus datos */}
            {seleccion.tipo === "sin_alta" &&
              seleccion.id === cita?.paciente_cita &&
              cita?.ficha_estado === "completada" && (
                <span className="etiqueta-ficha-recibida">Ficha recibida</span>
            )}
            <div className="seleccion-acciones">
              {/* Primero: completar alta (solo si la cita ya está guardada con esta persona) */}
              {cita?.id && seleccion.tipo === "sin_alta" && seleccion.id === cita.paciente_cita && (
                <button
                  type="button"
                  className="btn-mini btn-mini-primario"
                  onClick={() => {
                    onCerrar();
                    navigate("/dashboard/alta-paciente", {
                      state: { pacienteCitaId: cita.paciente_cita },
                    });
                  }}
                >
                  Completar alta
                </button>
              )}
              <button
                type="button"
                className="btn-mini btn-mini-secundario"
                onClick={() => setSeleccion(null)}
              >
                Cambiar
              </button>
            </div>
          </div>
        ) : (
          <div className="buscador-persona">
            <input
              type="text"
              placeholder="Busca paciente o persona..."
              value={busqueda}
              onChange={(e) => { setBusqueda(e.target.value); setMostrarLista(true); }}
              onFocus={() => setMostrarLista(true)}
            />
            {mostrarLista && (
              <ul className="lista-personas">
                <li onClick={() => elegirOpcion({ tipo: "personal", id: null, nombre: "Cita personal" })}>
                  Cita personal
                </li>
                <li
                  className="opcion-nueva"
                  onClick={() => {
                    // Usa lo que ya escribió como nombre
                    setPersonaNueva({ nombre: busqueda.trim(), apellido_paterno: "", apellido_materno: "", telefono: "", correo: "" });
                    setModoPersonaNueva(true);
                    setMostrarLista(false);
                    setBusqueda("");
                  }}
                >
                  + Agendar persona nueva{busqueda.trim() ? `: "${busqueda.trim()}"` : ""}
                </li>
                {opcionesFiltradas.map((o) => (
                  <li key={`${o.tipo}-${o.id}`} onClick={() => elegirOpcion(o)}>
                    {o.nombre}
                    {o.tipo === "sin_alta" && <span className="etiqueta-sin-alta">Sin alta</span>}
                  </li>
                ))}
                {opcionesFiltradas.length === 0 && (
                  <li className="sin-resultados">Sin resultados</li>
                )}
              </ul>
            )}
          </div>
        )}
        
        <label>Fecha de Inicio:</label>
        <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />

        <label>Hora de Inicio:</label>
        <input type="time" value={start_time} onChange={handlestart_timeChange} />

        <label>Fecha de Fin:</label>
        <input type="date" value={end_date} onChange={(e) => setend_date(e.target.value)} />

        <label>Hora de Fin:</label>
        <input type="time" value={end_time} onChange={handleend_timeChange} />

        <label>Motivo:</label>
        <input type="text" value={motivo} onChange={(e) => setMotivo(e.target.value)} />

        {cita?.id && loadingWhatsappManual && (
  <button type="button" className="whatsapp-manual-button" disabled>
    Cargando WhatsApp...
  </button>
)}

{cita?.id && whatsappManual?.puede_enviar && (
  <button
    type="button"
    className="whatsapp-manual-button"
    onClick={handleEnviarWhatsappManual}
  >
  <img
  src={whatsappIcon}
  alt="WhatsApp"
  className="whatsapp-manual-icon"
/>
<span>{whatsappManual.label || "Enviar WhatsApp"}</span>
  </button>
)}

        <div className="modal-buttons">
          <button onClick={handleGuardar} disabled={guardandoCita}>
            {guardandoCita ? "Guardando…" : "Guardar"}
          </button>
        {cita?.id && (
          <>
            {cita.status !== "cancelada" && (
              <button onClick={handleCancelarCita}>Cancelar Cita</button>
            )}

            <button onClick={handleEliminarCita}>Eliminar</button>
          </>
        )}

          <button onClick={onCerrar}>Atrás</button>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default ModalCita;
